import Parse from "parse"
import { getServerUrl } from "../utils"
import {axiosCall} from "../utils/axiosUtils"

/**
 * KFC-191 approach A: `volumeLibreService` is the self-service stock entered at reception. It
 * is only sent for hubs with a retail offer; elsewhere it stays undefined and the payload is
 * identical to what it was before.
 */
export async function updateProductStockFCVolume(productStockId, type, volume, volumeLibreService, transfer) {
	try {
		const url = `${getServerUrl()}/stocks/updateProductStockFCVolume`
		const data = {
			productStockId,
			type,
			volume
		}

		if (volumeLibreService !== undefined && volumeLibreService !== null) {
			data.volumeLibreService = volumeLibreService
		}

		// KFC-351: only a transfer fills this, whether declared on its own or revealed by a
		// recount. Every other call sends the same body as before.
		if (transfer) {
			data.transfer = transfer
		}
		
		const result = await axiosCall("PUT", url, data, {})
		
		return result.status === 200 && result.data.success
	}
	catch (e) {
		return false
	}
}

/**
 * Asks the server for the FoodCheri stock. The browser never talks to FoodCheri directly: it
 * cannot hold the credentials the call needs.
 *
 * Returns `null` when the stock is unknown, which is not zero — zero means everything is
 * pre-ordered and constrains the counter manager, unknown must constrain nothing.
 */
export async function getFCCurrentStock(productDispatchId, hubId) {
	try {
		const result = await Parse.Cloud.run("getFCCurrentStock", { productDispatchId, hubId })

		// `available` is what decides, not the presence of a number.
		if (!result || !result.available) return null

		return result.stock
	}
	catch (e) {
		// Keep the screen usable: a silent failure here used to abort the whole open handler.
		console.error(`getFCCurrentStock : stock FoodChéri indisponible pour ${productDispatchId} sur ${hubId}`, e)

		return null
	}
}
